<template>
  <div>
    <!-- Tela normal: botão Executar -->
    <div v-if="!props.printMode" class="mb-3 text-center">
      <button @click="abrirPrint" class="btn btn-primary">
        Executar
      </button>
    </div>

    <!-- Modo impressão: relatório -->
    <div v-else>
      <div v-if="loading" class="text-center">Carregando…</div>
      <div v-else>
        <div
          v-for="inst in data"
          :key="inst.instrutor_id"
          class="mb-4"
        >
          <div
            v-for="tur in inst.turmas"
            :key="tur.turma_id"
            class="ps-3 mb-2"
          >
            <h6 class="mb-2">
              Turma: {{ tur.turma_id }} – Horário: {{ tur.horario }} – Dia: {{ tur.dia_semana }} – Instrutor: {{ inst.instrutor_nome }}
            </h6>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Aluno</th>
                  <th>Nível</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="al in tur.alunos"
                  :key="`${tur.turma_id}-${al.aluno_id}`"
                >
                  <td>{{ al.aluno_nome }}</td>
                  <td>{{ al.nivel }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'

// Props de controle de exibição
const props = defineProps({
  printMode: { type: Boolean, default: false }
})

const router = useRouter()
const loading = ref(false)
const data = ref([])

// Navega para modo print, onde o ReportPrintWrapper será aplicado
function abrirPrint() {
  router.push({
    path: '/gestao/relatorios/print/alunos-por-turma',
    query: { title: 'Alunos por Turma' }
  })
}

// Quando em modo print, busca os dados agrupados por instrutor
onMounted(async () => {
  if (!props.printMode) return
  loading.value = true

  try {
    const res = await axios.get(
      '/gestao/relatorios/operacionais/alunos-por-turma'
    )
data.value = res.data.data || []
  } catch (e) {
    console.error('Erro ao buscar AlunosPorTurma:', e)
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
/* Reduzir tamanho de fontes e largura fixa de colunas */
.mb-2 { margin-bottom: .5rem; }
.mb-3 { margin-bottom: 1rem; }
.mb-4 { margin-bottom: 1.5rem; }
.ps-3 { padding-left: 1rem; }
.text-center { text-align: center; }
.fw-normal { font-weight: normal; }
.table-sm { font-size: .75rem; }

/* Cabeçalhos internos menores */
h5 { font-size: 1rem; }
h6 { font-size: .875rem; }

/* Tabelas com largura fixa e colunas iguais */
table {
  table-layout: fixed;
  width: 100%;
  font-size: .75rem;
}
th, td {
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
